import project_1 from '../images/project-1.png'
import project_2 from '../images/project-2.png'
import project_3 from '../images/project-3.png'
import project_4 from '../images/project-4.png'
import project_5 from '../images/project-5.png'
import project_6 from '../images/project-6.png'
import project_7 from '../images/project-7.png'
import project_8 from '../images/project-8.png'

import covidProject from '../images/Final_Report.pdf'

import resume from '../images/resume-example.pdf'



export const Bio = {
    name: "Lalitha Vadrevu",
    roles: [
      "Full Stack Developer",
      "Software Engineer",
      "Student",
      "AI Engineer"
    ],
    description:
      "I’m a motivated tech enthusiast, always excited to take up new challenges. With a love for learning and a commitment to delivering high-quality work, I’m ready to bring my skills and positive attitude to make a real impact. Let’s connect and create something amazing together!",
    github: "https://github.com/vlalithaunc",
    resume:
      resume,
    linkedin: "https://www.linkedin.com/in/lalitha-vadrevu/",
  };
  
  export const skills = [
    {
      title: "Frontend",
      skills: [
        {
          name: "React Js",
          image:
            "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
        },
        {
          name: "Next Js",
          image:
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
        },
        {
          name: "HTML",
          image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
        },
        {
          name: "CSS",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
        },
        {
          name: "JavaScript",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
        },
        {
          name: "Angular",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/Angular_full_color_logo.svg/2048px-Angular_full_color_logo.svg.png",
        }
      ],
    },
    {
      title: "Backend",
      skills: [
        {
          name: "Python",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
        },
        {
          name: "Golang",
          image:
            "https://go.dev/blog/go-brand/Go-Logo/PNG/Go-Logo_Blue.png",
        },
        {
          name: "Java",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
        },
        {
          name: "Node Js",
          image: "https://miro.medium.com/v2/resize:fit:800/1*v2vdfKqD4MtmTSgNP0o5cg.png",
        },
        {
          name: "Express Js",
          image:
            "data:image/png;base64,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",
        },
        {
          name: "PostgreSQL",
          image: "https://www.postgresql.org/media/img/about/press/elephant.png",
        },
        {
          name: "Firebase",
          image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
        },
      ],
    },
    {
      title: "Data Analytics",
      skills: [
        
        {
          name: "R",
          image:
            "https://images.sftcdn.net/images/t_app-icon-m/p/aa6d41ae-56eb-4438-9625-961714095b4a/1631223744/rstudio-server-RStudio%20Desktop-icn.png",
        },
      ],
    },
    {
      title: "Others",
      skills: [
        {
          name: "Git",
          image:
            "https://git-scm.com/images/logos/downloads/Git-Icon-Black.png",
        },
        {
          name: "GitHub",
          image:
            "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
        },
        {
          name: "Docker",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
        },
        {
          name: "Figma",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/3/33/Figma-logo.svg/1200px-Figma-logo.svg.png",
        },
      ],
    },
    {
      title: "Professional Certifications",
      skills: [
        {
          name: "AWS Developer - Associate",
          image: "https://partner.zoom.us/wp-content/uploads/2022/12/2022_Zoom-AWS_Lockup_RGB-1-e1672857797889-1024x760.png",
        },
        {
          name: "AWS Certified Cloud Practioner",
          image:
            "https://partner.zoom.us/wp-content/uploads/2022/12/2022_Zoom-AWS_Lockup_RGB-1-e1672857797889-1024x760.png",
        },
        {
          name: "Microsoft Office Specialist: Word",
          image:
            "https://images.credly.com/size/680x680/images/16bc9e00-43a7-421c-a775-a990fbc590ac/MOS_Word.png",
        },{
          name: "Microsoft Office Specialist: PowerPoint",
          image:
            "https://images.credly.com/size/680x680/images/b4fbd3ac-b964-4eaf-ac28-a286964ec49e/MOS_PowerPoint.png",
        },{
          name: "Microsoft Office Specialist: Excel",
          image:
            "https://images.credly.com/size/680x680/images/d0790dc7-5127-4262-a492-1b60030b0114/MOS_Excel.png",
        }
      ],
    },
  ];
  
  export const experiences = [
    {
      id: 0,
      img: "https://media.licdn.com/dms/image/C560BAQFuX_dfdguV2w/company-logo_200_200/0/1660585509250/the_financial_risk_group_logo?e=2147483647&v=beta&t=wcout5vayUEHDPzJ8CQ1_Nd2FfybS3vzcRquNfVis9s",
      role: "Full Stack Developer Intern",
      company: "Financial Risk Group (FRG)",
      date: "May 2023 - August 2023",
      desc: "Developed and tested a Go module for correlated multivariate simulation using Cholesky Factorization, which improved risk analysis and reduced computation time by 20%. Implemented 11 new SQL functions, modified over 500 lines of SQL parser code, created nearly 25 unit tests, and enhanced interactive graphical representations, all while utilizing tools like Git, Docker, and Phabricator for efficient project management.",
      skills: [
        "Golang",
        "Python",
        "SQL",
        "Mathematical Modeling",
        "Optimization"
      ]
    },
    {
      id: 0,
      img: "https://media.licdn.com/dms/image/C560BAQFuX_dfdguV2w/company-logo_200_200/0/1660585509250/the_financial_risk_group_logo?e=2147483647&v=beta&t=wcout5vayUEHDPzJ8CQ1_Nd2FfybS3vzcRquNfVis9s",
      role: "Full Stack Developer Intern",
      company: "Financial Risk Group (FRG)",
      date: "May 2022 - August 2022",
      desc: "Automated the creation of interactive visual representations of risk solution processes using a Go subsystem and Graph Theory, and collaborated with UI/UX teams to integrate it into the Django framework, enhancing user experience. Improved parallel performance in Python processes, reducing runtime by 20%, enhanced the Visualization of Risk (VOR) Stream product, and conducted code reviews and bug triage in an Agile environment while updating documentation.",
      skills: [
        "Go",
        "Python",
        "Dot",
        "Graph Theory",
        "Docker",
        "Linux",
        "Phabricator",
        "Documentation (Markdown)",
        "Unit Testing"
      ]
    },
  ];
  
  export const education = [
    {
      id: 0,
      img: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d7/North_Carolina_Tar_Heels_logo.svg/2560px-North_Carolina_Tar_Heels_logo.svg.png",
      school: "University of North Carolina at Chapel Hill ",
      date: "Aug 2020 - May 2024",
      grade: "3.80",
      desc: "Related Course Work: Data Structures, Discrete Structures, Analysis & Algorithms, Models of Languages and Computation, Files and Databases, Introduction to Software Engineering, NLP | Clubs: CS+SG (Computer Science for Social Good), Pearl Hacks, HackNC",
      degree: "Bachelor of Sciences in Computer Science",
    },
    {
      id: 1,
      img: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d7/North_Carolina_Tar_Heels_logo.svg/2560px-North_Carolina_Tar_Heels_logo.svg.png",
      school: "University of North Carolina at Chapel Hill ",
      date: "Aug 2020 - May 2024",
      grade: "3.80",
      desc: "Related Course Work:  Intro to Probability, Intro to Data Science, Methods of Data Analysis, Linear Algebra, Intro to Optimization ",
      degree: "Bachelor of Sciences in Statistics & Analytics",
    },
  ];
  
  export const projects = [
    {
      id: 0,
      title: "UNC CSXL Roster Management",
      date: "Jan 2024 - May 2024",
      description:
        "Contributed to the development of the UNC CSXL web app, which attracts over 300 weekly visitors. Key achievements include creating a roster management system for student organizations, enabling features like members-only events and admin privileges. Enhanced the frontend using Angular and TypeScript, and integrated it with a Python backend powered by FastAPI and PostgreSQL. Utilized Python’s RESTful APIs for membership management and SQLAlchemy ORM for efficient data handling on CloudApps.",
      image:
        project_1,
      tags: [
        "Docker",
        "CloudApps",
        "TypeScript",
        "Angular",
        "Python",
        "PostgreSQL",
        "RESTful APIS",
        "SQLAlchemy"
      ],
      category: "web app",
      github: "https://github.com/unc-csxl/csxl.unc.edu",
      webapp: "https://csxl-team-a3-comp590-24s.apps.unc.edu",
    },
    {
      id: 1,
      title: "Track My Leader",
      date: "Apr 2023 - May 2023",
      description:
        "Developed a data-driven web app using HTML/CSS, Python, and Flask for web scraping and analyzing governmental data on past presidents and North Carolina officials. Integrated data visualization and Twilio API to offer personalized voter registration information, improving civic engagement and data accessibility.",
      image:
        project_2,
      tags: ["Python", "Flask", "HTML", "CSS", "Twilio API", "Pandas"],
      category: "web app",
      github: 'https://github.com/DheyaM/HackNC2022',
      webapp: 'https://devpost.com/software/track-my-leader',
    },
    {
      id: 2,
      title: "Translate Me",
      date: "Oct 2022 - Present",
      description:
        "Built a resume translator that allows users to translate their resumes into any language. Utilized Python and Google Cloud Translate REST API for translation and developed a full-stack website with HTML and CSS for dynamic content and page routing.",
      image:
        project_3,
      tags: [
        "Python",
        "Google Cloud Translate API",
        "HTML",
        "CSS",
      ],
      category: "web app",
      github: "https://github.com/DheyaM/PearlHacks2022/",
      webapp: "https://devpost.com/software/translate-me-u9pv13",
    },{
      id: 3,
      title: "Tic-Tac-Toe",
      date: "Jun 2024 - Jul 2024",
      description:
        "Implented an optimal Tic-Tac-Toe AI using the Minimax algorithm to enhance gameplay strategy.",
      image:
        project_4,
      tags: [
        "Python",
        "Pygame",
        "MinMax Algorithm",
      ],
      category: "artificial intelligence",
      github: "https://github.com/vlalithaunc/ai-course/tree/main/tictactoe",
    },
    {
      id: 4,
      title: "Minesweeper",
      date: "Jun 2024 - Jul 2024",
      description:
        "Developed a Minesweeper game with logic for mine detection and flagging, incorporating a 3x3 grid to reveal cell values based on neighboring mines.",
      image:
        project_5,
      tags: [
        "Python",
        "Pygame",
      ],
      category: "artificial intelligence",
      github: "https://github.com/vlalithaunc/ai-course/tree/main/minesweeper",
    },{
      id: 5,
      title: "Crossword",
      date: "Jun 2024 - Jul 2024",
      description:
        "Developed an AI algorithm to generate engaging and challenging crossword puzzles.",
      image:
        project_6,
      tags: [
        "Python",
        "Backtracking Algorithm",
      ],
      category: "artificial intelligence",
      github: "https://github.com/vlalithaunc/ai-course/tree/main/crossword",
    },{
      id: 6,
      title: "Traffic Sign Detection",
      date: "Jun 2024 - Jul 2024",
      description:
        "Designed and implemented a neural network using TensorFlow to classify road signs from images, leveraging a labeled dataset for accurate sign recognition.",
      image:
      project_7,
      tags: [
        "Python",
        "Tensorflow",
        "sklearn.model_selection",
        "cv2",
      ],
      category: "artificial intelligence",
      github: "https://github.com/vlalithaunc/ai-course/tree/main/traffic",
  },{
  id: 7,
  title: "Covid Deaths with Pre-Existing Health Conditions",
  date: "Jan - Feb 2022",
  description:
    "Analyzed COVID-19 fatalities in individuals with pre-existing conditions using R, applying data analytics and machine learning techniques..",
  image:
  project_8,
  tags: [
    "R",
    "tidyverse",
    "ggplot",
    "corrplot",
  ],
  category: "artificial intelligence",
  webapp: covidProject
},
  ];


  
  export const TimeLineData = [
    { year: 2017, text: "Started my journey" },
    { year: 2018, text: "Worked as a freelance developer" },
    { year: 2019, text: "Founded JavaScript Mastery" },
    { year: 2020, text: "Shared my projects with the world" },
    { year: 2021, text: "Started my own platform" },
  ];